import { sortDates } from "../sortDates";
import { getBookingDate } from "../getBookingDate";

export const formatADRChartData = (
  bookedBookings,
  cancelledBookings,
  dataMode
) => {
  const bookedTotalsByDate = bookedBookings.reduce((acc, booking) => {
    const date = getBookingDate(booking, dataMode);
    if (!acc[date]) acc[date] = { totalAmount: 0, totalRoomDays: 0 };
    const numberOfRooms = booking.rooms.reduce(
      (sum, room) => sum + room.numberOfRooms,
      0
    );
    acc[date].totalAmount += booking.totalamount;
    acc[date].totalRoomDays += booking.totaldays * numberOfRooms;
    return acc;
  }, {});
  const cancelledTotalsByDate = cancelledBookings.reduce((acc, booking) => {
    const date = getBookingDate(booking, dataMode);
    if (!acc[date]) acc[date] = { totalAmount: 0, totalRoomDays: 0 };
    const numberOfRooms = booking.rooms.reduce(
      (sum, room) => sum + room.numberOfRooms,
      0
    );
    acc[date].totalAmount += booking.totalamount;
    acc[date].totalRoomDays += booking.totaldays * numberOfRooms;
    return acc;
  }, {});

  const labels = sortDates([
    ...new Set([
      ...Object.keys(bookedTotalsByDate),
      ...Object.keys(cancelledTotalsByDate),
    ]),
  ]);
  const bookedData = labels.map((date) => {
    const { totalAmount, totalRoomDays } = bookedTotalsByDate[date] || {
      totalAmount: 0,
      totalRoomDays: 0,
    };
    return totalRoomDays > 0
      ? Number((totalAmount / totalRoomDays).toFixed(2))
      : 0;
  });
  const cancelledData = labels.map((date) => {
    const { totalAmount, totalRoomDays } = cancelledTotalsByDate[date] || {
      totalAmount: 0,
      totalRoomDays: 0,
    };
    return totalRoomDays > 0
      ? Number((totalAmount / totalRoomDays).toFixed(2))
      : 0;
  });

  return {
    labels,
    datasets: [
      {
        label: "Booked",
        data: bookedData,
        backgroundColor: "rgba(54, 162, 235, 0.6)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
      {
        label: "Cancelled",
        data: cancelledData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ],
  };
};
